import styled from 'styled-components'

export const StyledPageTitle = styled.h2`
  color: var(--primary-black);
  font-size: 1.5rem;
`

export const StyledPageTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`
export const StyledPageSubtitle = styled.h3`
  color: var(--primary-black);
  font-size: 1.375rem;
  margin-top: 10px;
  font-weight: var(--regular);
`
